<template>
  <div id="tab-commonHawb" class="app-main-inner">
    <div class="form-card-wrapper">
      <el-card class="form-card" style="width: 100%;padding-bottom: 10px;">
        <el-form label-width="90px" label-position="left" style="height:100%;width: 1465px;">
          <div style="display: flex;justify-content: space-between">
            <el-form-item label="MAWB No." class="custom">
              <div style="display: flex;align-content: center;align-items: center">
                <el-input no="1" :value="AirExportUtils.mawbNoDispalyFormat(job.mbl)" style="width: 206px;" :disabled="true" />
                <el-tooltip :content="$t('queryJob.BillOfLadingInformationTracking')" placement="right">
                  <img :src="img.follow" style="width: 20px;height: 20px;cursor: pointer" :tip="$t('queryJob.BillOfLadingInformationTracking')" @click="showMBLDetailBtnClickHandler">
                </el-tooltip>

              </div>
            </el-form-item>
            <div>
              <span> HAWB No. </span>
              <cargo-input
                v-model="form.hblNbr2"
                :disabled="!isEditing"
                no="2"
                :auto-uppercase="isUppercase"
                style="width: 206px;"
                :class="importDifferenceField.hblNbr2 ? 'red-border' : ''"
              />
              <span
                v-if="viewSource !=='AeTabSubBill'"
                id="Insure"
                v-permission="['button_insurance_toInsure']"
                type="primary"
                :class="!isEditing?'el-button el-button--primary el-button--mini':'el-button el-button--primary el-button--mini is-disabled'"
                style="min-width:50px!important;margin-left:15px"
                no="Insure"
                @click="()=>{if (!isEditing){pm.toInsure()}}"
              >{{ $t('SeaExport.Insure') }}
              </span>
            </div>
            <div>
              <el-button
                no="3"
                type="primary"
                :disabled="!isEditing"
                @click="showAddressFormatDialog"
              >{{ $t('SeaExport.AntiTerroristFormattedAddress') }}</el-button>
              <el-button no="4" :disabled="!isEditing" type="primary" @click="copyFromOtherBillHandler"> {{ $t('SeaExport.CopyFromOtherBill') }} </el-button>
              <el-button no="5" :disabled="!isEditing" type="primary" @click="popUpAddressWindow"> {{ $t('SeaExport.CodeSearching') }} </el-button>
              <el-button no="6" :disabled="!isEditing" type="primary" @click="pm.copyMblCargoDoc()"> {{ $t('SeaExport.CopyTheMbl') }} </el-button>

            </div>
          </div>
          <div style="display: flex;justify-content: space-between">
            <div style="margin-right: 10px;">
              <el-form-item label="Shipper" class="custom">
                <div style="display: flex;width:520px">
                  <cargo-input
                    ref="shipperCode"
                    v-model="form.shipperCode"
                    :disabled="!isEditing"
                    no="7"
                    :class="importDifferenceField.shipperCode ? 'red-border' : ''"
                    :auto-uppercase="notUppercaseShipperConsigneNotify"
                    style="width:175px"
                  />
                  <cargo-company-select
                    no="8"
                    :method-params="{shipper:true,active:true}"
                    :disabled="!isEditing"
                    :default-value="form.shipperId||''"
                    style="display: inline-block;width:240px;margin-right: 5px"
                    :fields="['englishName']"
                    tag-name="englishName"
                    placeholder=" "
                    :class="importDifferenceField.shipperId ? 'red-border' : ''"
                    @change="data => {shipperChangeHandler(data)}"
                  />
                  <el-button no="9" type="primary" style="margin-left: 5px" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
                  <char-count inline :form="form" prefix="shipper" />
                </div>
              </el-form-item>
              <el-form-item class="label-none custom ">
                <cargo-input
                  ref="shipperLine1"
                  v-model="form.shipperLine1"
                  :disabled="!isEditing"
                  no="10"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine1 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine1','shipperLine2',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine2"
                  v-model="form.shipperLine2"
                  :disabled="!isEditing"
                  no="11"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine2 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine2','shipperLine3',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine3"
                  v-model="form.shipperLine3"
                  :disabled="!isEditing"
                  no="12"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine3 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine3','shipperLine4',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine4"
                  v-model="form.shipperLine4"
                  :disabled="!isEditing"
                  no="13"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine4 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine4','shipperLine5',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine5"
                  v-model="form.shipperLine5"
                  :disabled="!isEditing"
                  no="14"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.shipperLine5 ? 'red-border' : ''"
                  @dblclick.native="showShipperDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('shipperLine5','shipperLine6',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine6"
                  v-model="form.shipperLine6"
                  :disabled="!isEditing"
                  no="15"
                  :maxlength="maxChars"
                  :class="importDifferenceField.shipperLine6 ? 'red-border' : ''"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="shipperLine7"
                  v-model="form.shipperLine7"
                  :disabled="!isEditing"
                  no="150"
                  :maxlength="maxChars"
                  :class="importDifferenceField.shipperLine7 ? 'red-border' : ''"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  @dblclick.native="showShipperDialog"
                />
              </el-form-item>
              <el-form-item label="Consignee" class="custom">
                <div style="display: flex;width:520px">
                  <cargo-input
                    ref="consigneeCode"
                    v-model="form.consigneeCode"
                    :disabled="!isEditing"
                    no="16"
                    :class="importDifferenceField.consigneeCode ? 'red-border' : ''"
                    :auto-uppercase="notUppercaseShipperConsigneNotify"
                    style="width:175px"
                  />
                  <cargo-company-select
                    ref="consigneeId"
                    no="17"
                    :method-params="{consignee:true,active:true}"
                    :default-value="form.consigneeId||''"
                    :disabled="!isEditing"
                    style="display: inline-block;width:240px;margin-right: 5px"
                    :fields="['englishName']"
                    tag-name="englishName"
                    placeholder=" "
                    :class="importDifferenceField.consigneeId ? 'red-border' : ''"
                    @change="data => {consigneeChangeHandler(data)}"
                  />
                  <el-button no="18" type="primary" style="margin-left: 5px" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
                  <char-count inline :form="form" prefix="consignee" />
                </div>
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine1"
                  v-model="form.consigneeLine1"
                  :disabled="!isEditing"
                  no="19"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine1 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine1','consigneeLine2',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine2"
                  v-model="form.consigneeLine2"
                  :disabled="!isEditing"
                  no="20"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine2 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine2','consigneeLine3',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine3"
                  v-model="form.consigneeLine3"
                  :disabled="!isEditing"
                  no="21"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine3 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine3','consigneeLine4',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine4"
                  v-model="form.consigneeLine4"
                  :disabled="!isEditing"
                  no="22"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine4 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine4','consigneeLine5',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine5"
                  v-model="form.consigneeLine5"
                  :disabled="!isEditing"
                  no="23"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine5 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine5','consigneeLine6',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine6"
                  v-model="form.consigneeLine6"
                  :disabled="!isEditing"
                  no="24"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine6 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="consigneeLine7"
                  v-model="form.consigneeLine7"
                  :disabled="!isEditing"
                  no="240"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.consigneeLine7 ? 'red-border' : ''"
                  @dblclick.native="showConsigneeDialog"
                />
              </el-form-item>
              <div style="display: flex;flex-direction: column">
                <span>Airport of Departure</span>
                <cargo-input
                  v-model="form.airportOfDeparture"
                  :disabled="!isEditing"
                  no="25"
                  :auto-uppercase="isUppercase"
                  :class="importDifferenceField.airportOfDeparture ? 'red-border' : ''"
                />
              </div>
            </div>
            <div>
              <el-form-item label="Notify" class="custom">
                <div style="display: flex;width:520px">
                  <cargo-input
                    ref="notifyCode"
                    v-model="form.notifyCode"
                    :disabled="!isEditing"
                    no="26"
                    :auto-uppercase="notUppercaseShipperConsigneNotify"
                    style="width:175px"
                    :class="importDifferenceField.notifyCode ? 'red-border' : ''"
                  />
                  <cargo-company-select
                    ref="notifyId"
                    no="27"
                    :method-params="{notify:true,active:true}"
                    :default-value="form.notifyId||''"
                    :disabled="!isEditing"
                    style="display: inline-block;width:240px;margin-right: 5px"
                    :fields="['englishName']"
                    tag-name="englishName"
                    placeholder=" "
                    :class="importDifferenceField.notifyId ? 'red-border' : ''"
                    @change="data => {notifyChangeHandler(data)}"
                  />
                  <el-button type="primary" style="margin-left: 5px" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
                  <char-count inline :form="form" prefix="notify" />
                </div>
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="notifyLine1"
                  v-model="form.notifyLine1"
                  :disabled="!isEditing"
                  no="28"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.notifyLine1 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine1','notifyLine2',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="notifyLine2"
                  v-model="form.notifyLine2"
                  :disabled="!isEditing"
                  no="29"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.notifyLine2 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine2','notifyLine3',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="notifyLine3"
                  v-model="form.notifyLine3"
                  :disabled="!isEditing"
                  no="30"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.notifyLine3 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine3','notifyLine4',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="notifyLine4"
                  v-model="form.notifyLine4"
                  :disabled="!isEditing"
                  no="31"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.notifyLine4 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine4','notifyLine5',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="notifyLine5"
                  v-model="form.notifyLine5"
                  :disabled="!isEditing"
                  no="32"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.notifyLine5 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                  @change="CargoDocUtil.sftAddrChangeWrap('notifyLine5','notifyLine6',maxChars)"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="notifyLine6"
                  v-model="form.notifyLine6"
                  :disabled="!isEditing"
                  no="33"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.notifyLine6 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                />
              </el-form-item>
              <el-form-item :class="'label-none custom '">
                <cargo-input
                  ref="notifyLine7"
                  v-model="form.notifyLine7"
                  :disabled="!isEditing"
                  no="330"
                  :maxlength="maxChars"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :use-read-only="true"
                  :class="importDifferenceField.notifyLine7 ? 'red-border' : ''"
                  @dblclick.native="showNotifyDialog"
                />
              </el-form-item>
              <div style="display: flex;flex-direction: column">
                <span>Issued By</span>
                <cargo-rich-textarea
                  v-model="form.issuedBy"
                  no="34"
                  :disabled="!isEditing"
                  :text-chars="0"
                  :auto-uppercase="true"
                  :warning-count="-1"
                  style="height: 110px"
                  :class="importDifferenceField.issuedBy ? 'red-border' : ''"
                  @dblclick.native="showAdvanceTextDialog('Issued By',form.issuedBy,val=>{form.issuedBy=val})"
                />
              </div>
              <div style="display: flex;flex-direction: column">
                <span>Accounting Information</span>
                <cargo-rich-textarea
                  v-model="form.accountingInfo"
                  no="35"
                  :disabled="!isEditing"
                  :auto-uppercase="true"
                  :text-chars="0"
                  :warning-count="-1"
                  style="height: 110px"
                  :class="importDifferenceField.accountingInfo ? 'red-border' : ''"
                  @dblclick.native="showAdvanceTextDialog('Accounting Information',form.accountingInfo,val=>{form.accountingInfo=val})"
                />
              </div>
              <div style="display: flex;justify-content: space-between;margin-top: 39px;">
                <div style="display: flex;margin-right: 2px;">
                  <span>Freight Term</span>
                  <cargo-input
                    v-model="freightTerm"
                    no="36"
                    style="width: 190px"
                    :auto-uppercase="isUppercase"
                    :disabled="true"
                  />
                </div>
                <div style="display: flex;">
                  <span>{{ $t("SeaExport.PiecesType2") }}</span>
                  <el-input-number
                    no="37"
                    :value="form.insideQuantity || undefined"
                    controls-position="right"
                    :controls="false"
                    :min="0"
                    :max="999999999999"
                    :disabled="!isEditing"
                    style="width:130px;margin-right:5px"
                    :class="importDifferenceField.insideQuantity ? 'red-border' : ''"
                    @input="val=>{form.insideQuantity=val}"
                  />
                  <cargo-input
                    v-model="form.insidePacking"
                    :disabled="!isEditing"
                    no="38"
                    style="width: 115px"
                    :class="importDifferenceField.insidePacking ? 'red-border' : ''"
                    :auto-uppercase="isUppercase"
                  />
                </div>
              </div>
            </div>
            <div style="width: 300px; margin-left: 10px; padding-top: 5px;">
              <div style="display: flex">
                <span>Operation Requirements</span>
                <a v-if="airPortRequirementFileList && airPortRequirementFileList.length > 0" style="margin-left: 10px;text-decoration: underline;color: #0A0AFF" no="airPortRequirementText" @click="airPortRequirementClick">{{ airPortRequirementText }}</a>
              </div>
              <el-input
                v-model="airPortRequirement.operationRequirements"
                no="39"
                type="textarea"
                :rows="6"
                :disabled="true"
                style="height: 110px;width: 300px"
              />
            </div>
          </div>
          <div style="display: flex;justify-content: space-between">
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>To</span>
              <cargo-input
                v-model="form.podTo"
                :disabled="!isEditing"
                no="40"
                :auto-uppercase="isUppercase"
                :class="importDifferenceField.podTo ? 'red-border' : ''"
              />
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>By First Carrier</span>
              <cargo-input
                v-model="form.carrierBy"
                :disabled="!isEditing"
                no="41"
                :auto-uppercase="isUppercase"
                :class="importDifferenceField.carrierBy ? 'red-border' : ''"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>To</span>
              <cargo-input
                v-model="form.podTo1"
                :disabled="!isEditing"
                no="42"
                :auto-uppercase="isUppercase"
                :class="importDifferenceField.podTo1 ? 'red-border' : ''"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>By</span>
              <cargo-input
                v-model="form.carrierBy1"
                :disabled="!isEditing"
                no="43"
                :auto-uppercase="isUppercase"
                :class="importDifferenceField.carrierBy1 ? 'red-border' : ''"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>To</span>
              <cargo-input
                v-model="form.podTo2"
                :disabled="!isEditing"
                no="44"
                :auto-uppercase="isUppercase"
                :class="importDifferenceField.podTo2 ? 'red-border' : ''"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>By</span>
              <cargo-input
                v-model="form.carrierBy2"
                :disabled="!isEditing"
                no="45"
                :auto-uppercase="isUppercase"
                :class="importDifferenceField.carrierBy2 ? 'red-border' : ''"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 2px;">
              <span>Currency</span>
              <!--              <el-select v-model="form.currency" no="46">-->
              <!--                <el-option-->
              <!--                  v-for="item in AirExportConstants.CURRENCY"-->
              <!--                  :key="item"-->
              <!--                  :value="item"-->
              <!--                />-->
              <!--              </el-select>-->
              <cargo-advance-select
                no="46"
                :select-type="selectTypeNames.basic_data_Currency"
                :disabled="!isEditing"
                filterable
                :clearable="false"
                :static-options="currencyList"
                :default-value="form.currency"
                :class="importDifferenceField.currency ? 'red-border' : ''"
                @parentCallBack="p=>{currencyChangeHandler(p.value)}"
              />
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>WT/VAL</span>
              <el-select v-model="form.wtVal" :disabled="!isEditing" no="47" :class="importDifferenceField.wtVal ? 'red-border' : ''" @change="cpChangeHandler('wtVal')">
                <el-option label="PP" value="PP" />
                <el-option label="CC" value="CC" />
              </el-select>
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>Other</span>
              <el-select v-model="form.other" :disabled="!isEditing" no="48" :class="importDifferenceField.other ? 'red-border' : ''" @change="cpChangeHandler('other')">
                <el-option label="PP" value="PP" />
                <el-option label="CC" value="CC" />
              </el-select>
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>D.V.Carrier</span>
              <cargo-input
                v-model="form.carriageDv"
                :disabled="!isEditing"
                no="49"
                :class="importDifferenceField.carriageDv ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;width: 300px;margin-right: 2px;">
              <span>D.V. for Customs</span>
              <cargo-input
                v-model="form.dvForCustoms"
                :disabled="!isEditing"
                no="50"
                :class="importDifferenceField.dvForCustoms ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
          </div>
          <div style="width: 65%; display: flex;justify-content: flex-start;">
            <div style="display: flex;flex-direction: column; flex:1; margin-right: 10px;">
              <span>Airport of Destination</span>
              <cargo-input
                v-model="form.airportOfDestination"
                :disabled="!isEditing"
                no="51"
                :filter-chars="false"
                :class="importDifferenceField.airportOfDestination ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 10px;">
              <span>Flight/Date</span>
              <el-date-picker
                v-model="job.etd"
                no="52"
                :disabled="true"
                clearable
                type="datetime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </div>
            <div style="display: flex;flex-direction: column;margin-right: 10px;">
              <span>Amount of insurance</span>
              <cargo-input
                v-model="form.insuredAmount"
                :disabled="!isEditing"
                no="53"
                :class="importDifferenceField.insuredAmount ? 'red-border' : ''"
                :auto-uppercase="isUppercase"
              />
            </div>
          </div>
          <div>
            <div style="display: flex;flex-direction: column">
              <span>Handling Info</span>
              <cargo-rich-textarea
                v-model="form.handingInfo"
                no="54"
                :disabled="!isEditing"
                :text-chars="0"
                :auto-uppercase="true"
                :warning-count="-1"
                style="height: 110px"
                :class="importDifferenceField.handingInfo ? 'red-border' : ''"
                @dblclick.native="showAdvanceTextDialog('Handling Information',form.handingInfo,val=>{form.handingInfo=val})"
              />
            </div>
          </div>
          <hawb-part1 ref="part1" :cargo-doc="form" :job="job" :action="action" :is-uppercase-by-config="isUppercaseByConfig" style="width: 100%;" />

        </el-form>

      </el-card>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="!isEditing"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEditing" no="55" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="56"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog :visible.sync="billAddressDialog.visible" :job="billAddressDialog.job" :params="billAddressDialog.params" @callback="codeSearchCallback" />
    <!-- 反恐地址格式化弹窗 -->
    <address-format-dialog
      :visible.sync="addressFormatDialog.visible"
      :job="addressFormatDialog.job"
      :params="addressFormatDialog.params"
    />
    <!--单号抄录-->
    <copy-from-other-bill-dialog
      :doc-type="copyFromOtherBillDialog.docType"
      :visible.sync="copyFromOtherBillDialog.visible"
      @selected="transcribeEnterHandler"
    />
    <!--操作要求-->
    <operation-requirement-dialog
      :files="operationRequirementDialog.files"
      :visible.sync="operationRequirementDialog.visible"
    />
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import follow from '@/assets/follow.png'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import jobNoTranscribeDialog from '@/components/Cargo/Job/jobNoTranscribeDialog'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import HawbPart1 from './HAWBPart1'
import addressFormatDialog from './aeAddressFormatDialog'
import { CommonHAWBPM } from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/components/CommonHAWBPM'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import copyFromOtherBillDialog from '@/components/Cargo/Job/copyFromOtherBillDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { getToken } from '@/utils/auth'
import { AirPortRequirement } from '@/class/model/mdm/AirPortRequirement'
import operationRequirementDialog from '@/components/Cargo/Job/operationRequirementDialog'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { AirCargoDocUtil } from '@/class/cargo/model/utils/AirCargoDocUtil'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

export default {
  name: 'CommonHawb',
  components: {
    billAddressDialog,
    jobNoTranscribeDialog,
    cargoAdvanceSelect,
    cargoInput,
    cargoCompanySelect,
    HawbPart1,
    addressFormatDialog,
    cargoRichTextarea,
    copyFromOtherBillDialog,
    operationRequirementDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    job: {
      type: Object,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    viewSource: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      img: { follow },
      pm: new CommonHAWBPM(this),
      addrPM: new BillAddressCommonPM(this),
      AirExportConstants,
      AirExportUtils,
      config: {},
      selectTypeNames: TYPE_NAMES,
      // 反恐舱单-反恐地址格式化-弹窗
      addressFormatDialog: {
        visible: false,
        job: {},
        params: { cargoDocs: [] }
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0
        }
      },
      billAddressDialog: {
        visible: false,
        params: null,
        job: null
      },
      maxChars: 34,
      warningCount: 0,
      isUppercase: true,
      NumberUtils,
      CargoDocUtil,
      copyFromOtherBillDialog: {
        visible: false,
        docType: ''
      },
      freightTerm: '',
      airPortRequirement: new AirPortRequirement().fillDefaultValue().getData(),
      airPortRequirementText: `${this.$t('queryJob.AttachmentDescription')}：0${this.$t('CargoMsg.Cargo_Pcs')}`,
      airPortRequirementFileList: [],
      operationRequirementDialog: {
        visible: false,
        files: []
      },
      currencyList: [],
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    isEditing() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !(this.form && this.form.state > 2)
    },
    importDifferenceField() {
      if (!this.job) return {}
      return this.job.differenceHawbFields || {}
    }
  },
  watch: {

  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.config = cache.config
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    await this.createCurrency()
  },
  methods: {
    async createCurrency() {
      const currencyList = await getSpecificBasicData(basicCacheKeys.basic_data_Currency)
      this.currencyList = []
      for (const c of currencyList) {
        const currency = { ...c }
        if (currency.code === 'RMB') {
          currency.code = 'CNY'
        }
        this.currencyList.push(currency)
      }
    },
    fillView() {
      this.createCurrency()
      this.pm.fillView()
    },
    showAddressFormatDialog() {
      this.addressFormatDialog.job = {
        dischargingPortCode: this.job.dischargingPortCode,
        etd: this.job.etd
      }
      this.addressFormatDialog.params = { cargoDocs: [this.form] }
      this.addressFormatDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    transcribeCallback(data) {
      if (data.hasOwnProperty('cargoEnglishName')) {
        this.form.cargoEnglishName = data.cargoEnglishName
      }
      if (data.hasOwnProperty('mark')) {
        this.form.mark = data.mark
      }
    },
    copyFromOtherBillHandler() {
      this.copyFromOtherBillDialog.docType = this.form.docType
      this.copyFromOtherBillDialog.visible = true
    },
    popUpAddressWindow() {
      this.billAddressDialog.visible = true
      this.billAddressDialog.params = { ...this.form }
      this.billAddressDialog.job = this.job
      this.billAddressDialog.visible = true
    },

    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    showShipperDialog() {
      this.showAdvanceTextDialog(this.$t('Message.Shipper'), this.mergeShipperLine(), this.splitShipperLine, this.notUppercaseShipperConsigneNotify)
    },
    showConsigneeDialog() {
      this.showAdvanceTextDialog(this.$t('Message.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, this.notUppercaseShipperConsigneNotify)
    },
    showNotifyDialog() {
      this.showAdvanceTextDialog(this.$t('Message.Notify'), this.mergeNotifyLine(), this.splitNotifyLine, this.notUppercaseShipperConsigneNotify)
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['shipperLine7'] || '')
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['consigneeLine7'] || '')
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['notifyLine7'] || '')
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObject = null) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.formatObj = formatObject ? { ...this.advanceTextDialog.formatObj, ...formatObject } : this.advanceTextDialog.formatObj
      this.advanceTextDialog.visible = true
    },
    async executeTask() {
      this.addrPM.job = this.job
      this.addrPM.isPortFilter = true
      this.addrPM.shipperCodeField = ''
      this.addrPM.shipperField = 'shipperLine'
      this.addrPM.consigneeCodeField = ''
      this.addrPM.consigneeField = 'consigneeLine'
      this.addrPM.notifyCodeField = ''
      this.addrPM.notifyField = 'notifyLine'
      this.addrPM.viewFromBasic = true
      if (parseInt(this.config.get('syncMailingAddress')) === 1) {
        this.addrPM.aeSaveCheck()
      }
      this.pm.executeTask()
    },
    async showMBLDetailBtnClickHandler() {
      await cache.load(cacheName.CONFIG)
      const consoleURL = cache.config.get('AIMawbNoDetailUrl')
      // 对按钮点击进行埋点
      // LogStores.sendFunctionClickLogStoresByLabel('CargoWare-空运操作-分单信息页签-MBL详情')
      if (consoleURL) {
        const el = document.createElement('a')
        document.body.appendChild(el)
        el.href = consoleURL + '?MAWB=' + AirExportUtils.mawbNoDispalyFormat(this.job.mbl) + '&sessionId=' + getToken()
        el.target = '_blank'
        el.click()
        document.body.removeChild(el)
      } else {
        this.$message.warning(this.$t('queryJob.PleaseMaintainTheJumpAddress'))
      }
    },
    cpChangeHandler(type = '') {
      const from = this.form
      switch (type) {
        case 'wtVal' :
          this.$refs.part1.wtValChanged(from.wtVal)
          // CARGO-7981 币种无效
          if (from.wtVal === AirExportConstants.CC) {
            this.form.currency = 'USD'
          } else if (from.wtVal === AirExportConstants.PP) {
            this.form.currency = 'CNY'
          }
          break
        case 'other' :
          this.$refs.part1.otherChanged(from.other)
          break

        default : break
      }
    },
    transcribeEnterHandler(cargoDoc) {
      this.pm.transcribeEnterHandler(cargoDoc)
    },
    cWeightChangeHandler() {
      if (this.$refs.part1) {
        this.$refs.part1.cWeightChangeHandler()
      }
    },
    async fillModel(submitData = false) {
      if (this.$refs.part1) {
        await this.$refs.part1.fillModel(submitData)
      }
    },
    airPortRequirementClick() {
      this.operationRequirementDialog.files = this.airPortRequirementFileList
      this.operationRequirementDialog.visible = true
    },
    // 发货人选择
    async shipperChangeHandler(data) {
      await AirCargoDocUtil.shipperChangeFunc(this.form, data)
    },
    // 收货人选择
    async consigneeChangeHandler(data) {
      await AirCargoDocUtil.consigneeChangeFunc(this.form, data)
    },
    // 通知人选择
    async notifyChangeHandler(data) {
      await AirCargoDocUtil.notifyChangeFunc(this.form, data)
    },
    // 切换币种
    currencyChangeHandler(value) {
      const oldCurrency = this.form.currency
      this.form.currency = value
      if (RateUtil.useAmountCarryRule() && oldCurrency && this.form.currency && oldCurrency !== this.form.currency) {
        this.$message.warning(this.$t('queryJob.CurrencyChangeCheckDiff', [this.form.currency]))
      }
    }
  }
}
</script>

<style lang="scss">
  #app #tab-commonHawb {
    .el-form-item__content {
      width: 255px !important;
    }
    .label-none {
      .el-form-item__content {
        width: 490px !important;
      }
    }
    .not-click {
      pointer-events: none;
      button {
        color: #fff;
        background-color: #8cc8ff;
        border-color: #8cc8ff;
        cursor: not-allowed;
      }
    }
    button.not-click {
      color: #fff;
      background-color: #8cc8ff;
      border-color: #8cc8ff;
      cursor: not-allowed;
    }
  }
</style>
<style lang="scss" scoped>
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
